import { useState } from 'react';
import { BlacklistUserInfoGeneralBlockTypes } from './types';
import Table from '../../table/table';
import IconUp from '../../icons/up';
import IconDown from '../../icons/down';

import cn from './blacklist.module.css';

const BlacklistUserInfoGeneralBlock = ({
  info,
  columns,
  title,
  withoutTitle,
}: BlacklistUserInfoGeneralBlockTypes) => {
  const [expanded, setExpanded] = useState(true);

  return (
    <>
      {!withoutTitle && title && (
        <button
          type="button"
          className={cn.userInfoGeneralTitle}
          onClick={() => setExpanded(!expanded)}
        >
          {title}
          <div className={cn.userInfoGeneralTitleIcon}>
            {expanded ? (
              <IconUp width={16} height={16} />
            ) : (
              <IconDown width={16} height={16} />
            )}
          </div>
        </button>
      )}

      {expanded && (
        <div className={cn.userInfoBlockTableWrapper}>
          <Table
            columns={columns}
            data={info || []}
            onSort={() => {}}
            filters={{}}
            sort={{}}
            columnsLabels={{}}
            onFilterChange={() => {}}
            tableClassName={!info?.length ? cn.emptyContent : ''}
            tableTheadClassName={cn.staticHeader}
            tableBodyClassName={cn.userInfoTableBody}
          />
        </div>
      )}
    </>
  );
};

export default BlacklistUserInfoGeneralBlock;
